module.exports = __webpack_public_path__ + "static/media/adv_img_1.77e218c8.jpg";